<div class="text-center mt-5">
  <h2>{{ 'PRIVATE.passwordProtected' | translate }}</h2>
  <p class="mb-5">{{ 'PRIVATE.enterPagePassword' | translate }}</p>
  <div>
    <input
      type="password"
      pInputText
      placeholder="Password"
      (keydown.enter)="submitPassword()"
      [(ngModel)]="password"
      style="width: 300px"
      [class.error]="!!this.error()"
    />
    @if (error()) {
      <p style="color: #d84242">{{ error() }}</p>
    }
    <div class="mt-5" style="width: 300px; margin: 0 auto">
      <app-button
        [fullWidth]="true"
        (click)="submitPassword()"
        label="{{ 'COMMON.enter' | translate }}"
      ></app-button>
    </div>
  </div>
</div>
